<section>
  <div>
    <div class="inner-wrap">
      <p class="text-center">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany">
      </p>
      <h2>CHANGE PASSWORD</h2>
      <form [formGroup]="resetPasswordForm">
        <div class="form-group">
          <label>Old Password:</label>
          <div class="password-wrapper">
            <input
              [type]="passwordVisible2 ? 'text' : 'password'"
              class="form-control"
              autocomplete="off"
              formControlName="oldPassword"
              placeholder="Old Password"
            />
            <i
              class="fa"
              [ngClass]="passwordVisible2 ? 'fa-eye' : 'fa-eye-slash'"
              (click)="togglePasswordVisibility2()"
            ></i>
          </div>
          <div
            *ngIf="resetPasswordForm.get('oldPassword').touched && resetPasswordForm.controls['oldPassword'].hasError('required')"
            class="form-control-error-custom">
            Please enter old password.
          </div>
        </div>

        <div class="form-group">
          <label>New Password:</label>
          <div class="password-wrapper">
            <input
              [type]="passwordVisible1 ? 'text' : 'password'"
              class="form-control"
              autocomplete="off"
              placeholder="New Password"
              formControlName="password"
            />
            <i
              class="fa"
              [ngClass]="passwordVisible1 ? 'fa-eye' : 'fa-eye-slash'"
              (click)="togglePasswordVisibility1()"
            ></i>
          </div>
          <div
            *ngIf="resetPasswordForm.controls['password'].hasError('pattern') && resetPasswordForm.controls['password'].touched"
            class="form-control-error-custom">
            <ul style="padding-left: 1rem; text-align: left; margin-top: 0.25rem; margin-bottom: 0;">
              <li>Please enter a minimum of 8 characters.</li>
              <li>At least one lowercase and one uppercase letter.</li>
              <li>At least one number.</li>
              <li>At least one special character.</li>
            </ul>
          </div>
        </div>

        <div class="form-group">
          <label>Confirm Password:</label>
          <div class="password-wrapper">
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              class="form-control"
              autocomplete="off"
              formControlName="confirmPassword"
              placeholder="Confirm Password"
            />
            <i
              class="fa"
              [ngClass]="passwordVisible ? 'fa-eye' : 'fa-eye-slash'"
              (click)="togglePasswordVisibility()"
            ></i>
          </div>
          <div
            *ngIf="resetPasswordForm.get('password').touched && resetPasswordForm.get('confirmPassword').touched && resetPasswordForm.get('password').value !== resetPasswordForm.get('confirmPassword').value"
            class="form-control-error-custom">
            Passwords entered do not match.
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-primary btn-block mr-2 mb-2"
            style="margin-top: 10px;"
            [disabled]="!resetPasswordForm.valid"
            (click)="submitPassword()">
            Reset Password
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
